import  {eXcell,__extends} from './eXcell';
import {dhx4} from '../../global/dhx4OrDhx';

var eXcell_txt = (function (_super) {
    __extends(eXcell_txt, _super);
    function eXcell_txt(a) {
        _super.call(this);
        if (a) {
            this.cell = a;
            this.grid = this.cell.parentNode.grid;
        }
    }
    eXcell_txt.prototype.edit = function () {
        this.val = this.getValue();
        this.obj = document.createElement("TEXTAREA");
        this.obj.className = "dhx_textarea";
        this.obj.onclick = function (g) {
            (g || event).cancelBubble = true;
        };
        var c = this.grid.getPosition(this.cell);
        this.obj.value = this.val;
        this.obj.style.display = "";
        this.obj.style.textAlign = this.cell.style.textAlign;
        document.body.appendChild(this.obj);
        if (dhx4.isOpera) {
            this.obj.onkeypress = function (g) {
                if (g.keyCode == 9 || g.keyCode == 27) {
                    return false;
                }
            };
        }
        this.obj.onkeydown = function (h) {
            var g = h || event;
            if (g.keyCode == 9 || g.keyCode == 27) {
                window.globalActiveDHTMLGridObject.entBox.focus();
                window.globalActiveDHTMLGridObject.doKey({
                    keyCode: g.keyCode,
                    shiftKey: g.shiftKey,
                    srcElement: "0"
                });
                return false;
            }
        };
        this.obj.style.left = c[0] + "px";
        this.obj.style.top = c[1] + this.cell.offsetHeight + "px";
        var e = null;
        if (this.cell.offsetWidth < 200) {
            e = 200;
        }
        else {
            e = this.cell.offsetWidth;
        }
        this.obj.style.width = e + 16 + "px";
        if (dhx4.isIE) {
            this.obj.select();
            this.obj.value = this.obj.value;
        }
        this.obj.focus();
    };
    eXcell_txt.prototype.detach = function () {
        var c = "";
        c = this.obj.value;
        if (c == "") {
            this.cell._clearCell = true;
        }
        else {
            this.cell._clearCell = false;
        }
        this.setValue(c);
        document.body.removeChild(this.obj);
        this.obj = null;
        return this.val != this.getValue();
    };
    eXcell_txt.prototype.getValue = function () {
        if (this.obj) {
            return this.obj.value;
        }
        if (this.cell._clearCell) {
            return "";
        }
        if (typeof this.cell._brval != "undefined") {
            return this.cell._brval;
        }
        if (!this.grid.multiLine) {
            return this.cell._brval || this.cell.innerHTML;
        }
        else {
            return (this.cell._brval ||
                this.cell.innerHTML.replace(/<br[^>]*>/gi, "\n")._dhx_trim());
        }
    };
    return eXcell_txt;
})(eXcell);
eXcell_txt.prototype.setValue = function (a) {
    this.cell._brval = a;
    if (!a || a.toString()._dhx_trim() == "") {
        a = "&nbsp;";
        this.cell._clearCell = true;
    }
    else {
        this.cell._clearCell = false;
    }
    if (!this.grid.multiLine || this.cell._clearCell) {
        this.setCValue(a, this.cell._brval);
    }
    else {
        this.setCValue(a.replace(/\n/g, "<br/>"), a);
    }
};
window.eXcell_txt = eXcell_txt;



// WEBPACK FOOTER //
// ./goingsrc/dx/dxSource/components/gridXCell/eXcell_txt.js